export default __webpack_public_path__ + "d40cef3539e6f8d371c53a1ae84e0853.png";